"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Experience = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const date_fns_1 = require("date-fns");
const locale_1 = require("date-fns/locale");
const renderer_1 = require("@react-pdf/renderer");
const types_1 = require("@src/types");
const Date_1 = require("./Date");
const ApplicantProfilePDF_styles_1 = require("./ApplicantProfilePDF.styles");
function getDatesAndDiff(dates, type, actualLocale) {
    if (!dates[0]) {
        return;
    }
    const isCertificate = type === types_1.ProfileExperienceType.certificate;
    const dateFormat = 'LLLL yyyy';
    const locale = { locale: actualLocale === 'sk' ? locale_1.sk : locale_1.enUS };
    if (!dates[1]) {
        return (0, date_fns_1.format)((0, date_fns_1.parseISO)(dates[0]), dateFormat, locale);
    }
    const dateFrom = (0, date_fns_1.format)((0, date_fns_1.parseISO)(dates[0]), dateFormat, locale);
    const dateTo = (0, date_fns_1.format)((0, date_fns_1.parseISO)(dates[1]), dateFormat, locale);
    if (isCertificate) {
        return [dateFrom, dateTo];
    }
    const dateDiff = (0, date_fns_1.formatDistance)((0, date_fns_1.parseISO)(dates[1]), (0, date_fns_1.parseISO)(dates[0]), locale);
    return [dateFrom, dateTo, dateDiff];
}
const Experience = ({ experiences, type, actualLocale, }) => {
    if (!experiences) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: experiences
            .filter(experience => { var _a; return ((_a = experience.profileExperience) === null || _a === void 0 ? void 0 : _a.type) === type; })
            .sort((a, b) => {
            if (!b.to || (0, date_fns_1.isBefore)((0, date_fns_1.parseISO)(a.to), (0, date_fns_1.parseISO)(b.to))) {
                return 1;
            }
            return -1;
        })
            .map(experience => {
            var _a, _b, _c;
            const dateFrom = experience.from ? experience.from.toString() : undefined;
            const dateTo = experience.to ? experience.to.toString() : undefined;
            const experienceDates = getDatesAndDiff([dateFrom, dateTo], type, actualLocale);
            const marginStyle = experience.skillsUsed ? { marginTop: 8 } : {};
            return ((0, jsx_runtime_1.jsxs)(renderer_1.View, { style: [ApplicantProfilePDF_styles_1.styles.sectionRow, { marginTop: 16 }], wrap: false, children: [(0, jsx_runtime_1.jsx)(renderer_1.View, { style: { width: '33%' }, wrap: false, children: (0, jsx_runtime_1.jsx)(Date_1.Date, { dates: experienceDates, type: (_a = experience.profileExperience) === null || _a === void 0 ? void 0 : _a.type }) }), (0, jsx_runtime_1.jsxs)(renderer_1.View, { style: { width: '66%' }, wrap: false, children: [(0, jsx_runtime_1.jsx)(renderer_1.Text, { style: [ApplicantProfilePDF_styles_1.styles.title, { fontWeight: 'bold', marginBottom: 4 }], wrap: false, children: experience.title }), (0, jsx_runtime_1.jsx)(renderer_1.Text, { style: ApplicantProfilePDF_styles_1.styles.experienceSubtitle, wrap: false, children: (_b = experience.profileExperience) === null || _b === void 0 ? void 0 : _b.name }), (0, jsx_runtime_1.jsx)(renderer_1.Text, { style: ApplicantProfilePDF_styles_1.styles.shadowText, wrap: false, children: experience.description }), (0, jsx_runtime_1.jsx)(renderer_1.View, { style: [ApplicantProfilePDF_styles_1.styles.sectionRowWrap, marginStyle], wrap: false, children: (_c = experience.skillsUsed) === null || _c === void 0 ? void 0 : _c.map(skill => ((0, jsx_runtime_1.jsx)(renderer_1.View, { style: ApplicantProfilePDF_styles_1.styles.tag, wrap: false, children: (0, jsx_runtime_1.jsx)(renderer_1.Text, { style: ApplicantProfilePDF_styles_1.styles.tagText, wrap: false, children: skill.value }) }, skill.value))) })] })] }, experience.id));
        }) }));
};
exports.Experience = Experience;
